import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import { TableRowActions } from './TableRowActions';

export const TableRow = memo(
  ({ value, children, isFirstColumn, data, context, cellStyle, sx, useHorizontalActions = true }) => (
    <Flex
      sx={{
        width: '100%',
        height: '100%',
        padding: '8px',
        gap: '16px',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        ...cellStyle,
        ...sx,
      }}
    >
      <Flex
        sx={{
          color: 'text.main',
          fontSize: '14px',
          lineHeight: '20px',
          fontWeight: '400',
          width: isFirstColumn ? `calc(100% - ${useHorizontalActions ? '24px' : '72px'})` : '100%',
        }}
      >
        {children || value}
      </Flex>
      {isFirstColumn && context.rowActions?.items?.length > 0 && (
        <Box className="table-item-actions" minWidth="24px" minHeight="24px" id={data.id || data.rowId}>
          <TableRowActions row={data} rowActions={context.rowActions} useHorizontalActions={useHorizontalActions} />
        </Box>
      )}
    </Flex>
  ),
);

TableRow.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.bool, PropTypes.object]),
  children: PropTypes.node,
  isFirstColumn: PropTypes.bool,
  data: PropTypes.object,
  context: PropTypes.object,
  cellStyle: PropTypes.object,
  useHorizontalActions: PropTypes.bool,
  sx: PropTypes.object,
};

TableRow.defaultProps = {
  value: null,
  children: null,
  isFirstColumn: false,
  data: {},
  context: {},
  cellStyle: {},
  useHorizontalActions: true,
  sx: {},
};
